/* eslint-disable complexity */
/* eslint-disable max-statements */
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import loadable from "@loadable/component";
import {APPOINTMENT_STATE, PRICE_DISCOVERY} from "../../../../client/constants/seller-diy-constants";
import { MAP_TYPE, NUMBER } from "../../../constants/app-constants";
import Error from "../../shared/error";
import RtoInfoLoader from "../rto-info-loader";
import { useLocation } from "react-router";
import parseLocationSearchParams from "../../../utils/helpers/parse-location-search-params";
import GooglemapScript from "../googlemap-script";
import { OFFLINE_FLOW_STATES, PRICE_DISCOVERY_AUCTION_RUNNING, SCREEN_TYPES } from "../post-inspection-diy/constant";
import { SELL_TO_OPTIONS } from "../post-inspection-diy-landing-page/constant";
import PostInspectionMarketplace from "../../mobile/post-inspection-marketplace";
import { getDeviceType } from "../../../utils/helpers/device-type";

const PostInspectionDiyOffline = loadable(() => import("../post-inspection-diy-offline"));
const PostInspectionDiy = loadable(() => import("../post-inspection-diy"));
const PostInspectionDiyPll = loadable(() => import("../post-inspection-diy-pll"));
const PostInspectionDiyOdometer = loadable(() => import("../post-inspection-diy-odometer"));
const PostInspectionFranchise = loadable(() => import("../post-inspection-franchise"));
const PostInspectionDiyLeadmon = loadable(() => import("../post-inspection-diy-leadmon"));
const PostInspectionDiyLandingPage = loadable(() => import("../post-inspection-diy-landing-page"));

const PostInspectionDiyContainer = ({
    inspectionResponse,
    getCombinedDiyDetailsConnect,
    setDiyDetailsConnect,
    pageLoading,
    loaderTitle,
    setPageLoadingConnect,
    leadMonDetail,
    showSelfBought = false,
    selectFlowOfflineConnect = () => {},
    setIsFetchedConnect
}) => {
    const {
        isResetAuctionFlowActive,
        appointmentState,
        priceDiscovery,
        auction = {},
        screen,
        flowData = {},
        token,
        featureData: {
            c2cFlag = false
        } = {}
    } = inspectionResponse || {};
    const { selectedFlow } = flowData || {};
    const showOfflineLanding = selectedFlow === OFFLINE_FLOW_STATES.NOT_SELECTED;
    const showOffline = selectedFlow === OFFLINE_FLOW_STATES.OFFLINE;
    const { customerAuctionCount } = auction || {};
    const { isLeadMonActive = false } = leadMonDetail || {};
    const isPriceDiscoveryStarted = priceDiscovery !== PRICE_DISCOVERY.NOT_STARTED;
    const [isError, setIsError] = useState(false);
    const [showOfflinePage, setShowOfflinePage] = useState(false);
    const [showOfflineLandingPage, setShowOfflineLandingPage] = useState(showOfflineLanding);
    const [showC2c, setShowC2c] = useState(c2cFlag);
    const location = useLocation();
    const queryObj = parseLocationSearchParams(location.search);
    const { screen: showLoaderScreen = "" } = queryObj || {};
    const selectedBusiness = window.sessionStorage.getItem("b-key");
    const isMobile = getDeviceType().type === "Mobile";

    useEffect(() => {
        if (!loaderTitle) setPageLoadingConnect(true);
        getCombinedDiyDetailsConnect(inspectionResponse, showLoaderScreen).then((response) => {
            setDiyDetailsConnect(response);
            setIsFetchedConnect(true);
            window.setTimeout(() => {
                const { continueLoading = false } = response || {};
                if (!continueLoading) setPageLoadingConnect(false);
                if (showOffline) setShowOfflinePage(true);
            }, NUMBER.THOUSAND);
        // eslint-disable-next-line no-unused-vars
        }).catch((e) => {
            setIsError(true);
            setPageLoadingConnect(false);
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleSelection = (id) => {
        selectFlowOfflineConnect(token, { selectedFlow: id }).then(() => {
            if (id === SELL_TO_OPTIONS.OFFLINE) setShowOfflinePage(true);
            else setShowOfflinePage(false);
            setShowOfflineLandingPage(false);
        }).catch(() => {});
    };

    const getloaderTitle = () => {
        if (loaderTitle) return loaderTitle;
        if (customerAuctionCount === NUMBER.ZERO && screen === SCREEN_TYPES.DIRECT_OCB) return "Evaluating your car inspection details...";
        return "Fetching vehicle details";
    };

    const handleSwitch = () => {
        setShowOfflinePage(prev => !prev);
    };

    if (isError) return <Error />;
    if (showC2c && selectedBusiness !== "cs24" && isMobile) return <PostInspectionMarketplace setShowC2c={setShowC2c} />;
    if (showSelfBought) return <PostInspectionFranchise />;
    if (isLeadMonActive) return <PostInspectionDiyLeadmon />;
    if (isResetAuctionFlowActive && isPriceDiscoveryStarted) return <PostInspectionDiyOdometer />;
    if (appointmentState === APPOINTMENT_STATE.DEAL_LOST) return <PostInspectionDiyPll />;
    if (showOfflineLandingPage) return <PostInspectionDiyLandingPage handleSelection={handleSelection} />;
    if (showOfflinePage) {
        return (
            <React.Fragment>
                { pageLoading && <RtoInfoLoader title={getloaderTitle()} /> }
                <PostInspectionDiyOffline handleSwitch={handleSwitch} />
            </React.Fragment>);
    }
    return (
        <React.Fragment>
            { pageLoading && <RtoInfoLoader title={getloaderTitle()} /> }
            {PRICE_DISCOVERY_AUCTION_RUNNING.includes(priceDiscovery) &&  <GooglemapScript mapType={MAP_TYPE.GOOGLE} />}
            <PostInspectionDiy handleSwitch={handleSwitch} />
        </React.Fragment>
    );
};

PostInspectionDiyContainer.propTypes = {
    inspectionResponse: PropTypes.object,
    getCombinedDiyDetailsConnect: PropTypes.func,
    setDiyDetailsConnect: PropTypes.func,
    setPageLoadingConnect: PropTypes.func,
    pageLoading: PropTypes.bool,
    loaderTitle: PropTypes.string,
    leadMonDetail: PropTypes.bool,
    showSelfBought: PropTypes.bool,
    showOfflineFlow: PropTypes.bool,
    selectFlowOfflineConnect: PropTypes.func,
    isFetched: PropTypes.bool,
    setIsFetchedConnect: PropTypes.func
};

export default PostInspectionDiyContainer;
